export interface DurationDiscountTier {
  minimumMonths: number
  billedMonths: number
}

export const DURATION_DISCOUNT_TIERS: readonly DurationDiscountTier[] = [
  { minimumMonths: 12, billedMonths: 10 },
  { minimumMonths: 6, billedMonths: 5.5 },
]

export function billedMonthsForDuration(months: number): number {
  if (!Number.isFinite(months) || months < 1) {
    throw new Error(`Invalid service duration: ${String(months)} months`)
  }

  const [annualTier, halfYearTier] = DURATION_DISCOUNT_TIERS
  const discountMonths = months >= annualTier.minimumMonths
    ? Math.floor(months / annualTier.minimumMonths) * (annualTier.minimumMonths - annualTier.billedMonths)
    : Math.floor(months / halfYearTier.minimumMonths) * (halfYearTier.minimumMonths - halfYearTier.billedMonths)
  return months - discountMonths
}
